import { getApiClient } from './ApiClient'

export const brazeCampaignListPromise = (params) => {
  return getApiClient()
    .get('/braze-campaigns', { params })
    .then(resp => resp.data)
}

export const brazeCampaignDetailPromise = (id) => {
  return getApiClient()
    .get(`/braze-campaigns/${id}`)
    .then(resp => resp.data)
}

export const brazeCampaignCreatePromise = (body) => {
  return getApiClient()
    .post('/braze-campaigns', { body })
    .then(resp => resp.data)
}

export const brazeCampaignUpdatePromise = (id, body) => {
  return getApiClient()
    .put(`/braze-campaigns/${id}`, { body })
    .then(resp => resp.data)
}
